import { createSelector } from 'reselect'
import { isOrganicSearch } from 'lib/search/searchUtils'
import {
  isAndroid,
  isApple,
  isIOS,
  isMobileDevice,
} from 'lib/web/deviceUtils'

export const hasOrganicReferrer = createSelector(
  (state: App.State) => state.system.referrer,
  (referrer) => isOrganicSearch(referrer),
)

export const isAndroidSel = createSelector(
  (state: App.State) => state.system.device,
  (device) => isAndroid(device.osName),
)

export const isAppleSel = createSelector(
  (state: App.State) => state.system.device,
  (device) => isApple(device.osName),
)

export const isIOSSel = createSelector(
  (state: App.State) => state.system.device,
  (device) => isIOS(device.osName),
)

export const isCurrentDeviceMobile = createSelector(
  (state: App.State) => state.system.device,
  (device): boolean => isMobileDevice(device),
)

export const isHeadlessModeSel = (state: App.State) => state.system.headlessMode

export const isMobileAppSel = createSelector(
  (state: App.State) => isCurrentDeviceMobile(state),
  (state: App.State) => isHeadlessModeSel(state),
  (isMobileDevice, isHeadlessMode) => isMobileDevice && isHeadlessMode,
)

export const useMobileNativeAppAuth = createSelector(
  (state: App.State) => state.system.headlessMode,
  (headlessMode) => {
    return headlessMode &&
      typeof window !== 'undefined' &&
      (
        window.webkit?.messageHandlers?.authenticateUser ||
        window.appInterface
      )
  },
)
